import React from 'react'
import CssSpinner from './CssSpinner'
import { observer } from 'mobx-react'

const Loader = observer(props => {
  if (props.isLoading) {
    return <CssSpinner />
  }
  const Component = props.children
  return Component
})

export default Loader
  


// WEBPACK FOOTER //
// ./src/components/generic/Loader.js